import React, { useState } from "react";
import { useContent } from "../../../../../contexts/contentContext/contentContext.js";
import Button from "../../../../Elements/Button/Button.js";
import { useModal } from "../../../../../contexts/modalContext/modalContext.js";
import apiRequest from "../../../../../utils/ApiRequest/apiRequest.js";
import { useToasts } from "react-toast-notifications";
import config from "config";
import ToastHtmlComponent from "../../../../Reusable/ToastHtmlComponent/ToastHtmlComponent.js";

const RetrieveCodesModal = () => {
  const { getTextByKey } = useContent();
  const [emailToRecover, setEmailToRecover] = useState("");
  const { closeModal } = useModal();
  const { addToast } = useToasts();

  //recover function
  const retrieveCodes = async () => {
    const parameters = {
      Email: emailToRecover,
    };
    const response = await apiRequest(
      "UploadCodes",
      "ClientSendReconstructedCodesToMail",
      parameters,
      "POST"
    );
    if (response.status === "success") {
      if (response.data === "Good") {
        addToast(getTextByKey("profilecodes-recover-codes-sent"), {
          appearance: "success",
        });
      } else if ((response.data = "NotExists")) {
        addToast(getTextByKey("profilecodes-recover-no-codes"), {
          appearance: "error",
        });
      } else if (response.data === "Bad") {
        addToast(getTextByKey("profilecodes-recover-not-valid-email"), {
          appearance: "error",
        });
      } else {
        let errText = getTextByKey("api-error");
        errText = errText.replace("#ERRORNUM#", response.data);
        errText = errText.replace("#SYSMAIL#", "contact-us");
        errText = errText.replace("#SYSMAIL#", config.supportmail);
        errText = errText.replace("#SYSMAIL#", "contact-us");
        addToast(<ToastHtmlComponent htmlStr={errText} />, {
          appearance: "error",
        });
      }
    } else {
      let errText = getTextByKey("api-error");
      errText = errText.replace("#ERRORNUM#", response.data);
      errText = errText.replace("#SYSMAIL#", "contact-us");
      errText = errText.replace("#SYSMAIL#", config.supportmail);
      errText = errText.replace("#SYSMAIL#", "contact-us");
      addToast(<ToastHtmlComponent htmlStr={errText} />, {
        appearance: "error",
      });
    }

    closeModal();
  };

  return (
    <div className="retrieve-codes-modal">
      <div className="top-section">
        <div className="modal-content">
          <div className="modal-body">
            <div>
              <h1>{getTextByKey("profilecodes-recover-modal-title")}</h1>
              <p>{getTextByKey("profilecodes-recover-codes-text")}</p>
              <label></label>
              <input
                placeholder={getTextByKey("profilecodes-recover-codes-mail")}
                value={emailToRecover}
                type="text"
                onChange={(e) => {
                  setEmailToRecover(e.target.value);
                }}
              />
            </div>
            <div className="actions">
              <Button
                buttonClass="recover-button"
                onClick={() => {
                  retrieveCodes();
                }}
              >
                {getTextByKey("profilecodes-recover-codes-ok")}
              </Button>
              <Button
                gray
                buttonClass="recover-button"
                onClick={() => {
                  closeModal();
                }}
              >
                {getTextByKey("profilecodes-recover-codes-cancel")}
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="bottom-section"></div>
    </div>
  );
};

export default RetrieveCodesModal;
